import { Flex } from 'antd';
import React from 'react';
import { useIsTablet } from '../../hooks/useBreakpoint';
import { MultiProgress } from '../MultiProgress/MultiProgress';

type ProgressType = {
	current: number;
	total: number;
};

interface Props {
	teaching: ProgressType;
	training: ProgressType;
	payment: ProgressType;
	trainingTeaching: ProgressType;
}

const StatsSection: React.FC<Props> = ({ trainingTeaching, teaching, training, payment }) => {
	const isTablet = useIsTablet();

	const items = [
		{
			label: 'Výuka',
			items: [
				{
					id: 'vyuka',
					percent: (teaching.current / teaching.total) * 100,
					format: () => (
						<>
							<span>{teaching.current}</span>
							{`/${teaching.total}`}
						</>
					),
				},
			],
		},
		{
			label: 'Výcvik',
			items: [
				{
					id: 'vycvik',
					percent: (training.current / training.total) * 100,
					format: () => (
						<>
							<span>{training.current}</span>
							{`/${training.total}`}
						</>
					),
				},
				{
					id: 'vycvikTeaching',
					percent: (trainingTeaching.current / trainingTeaching.total) * 100,
					format: () => (
						<>
							<span>{trainingTeaching.current}</span>
							{`/${trainingTeaching.total}`}
						</>
					),
				},
			],
		},
		{
			label: 'Platba',
			items: [
				{
					id: 'platba',
					percent: (payment.current / payment.total) * 100,
					format: () => `${payment.current} Kč`,
				},
			],
		},
	];

	return (
		<Flex gap={isTablet ? 10 : 40} style={{ marginBottom: '20px' }} justify={isTablet ? 'center' : 'flex-start'}>
			{items.map(item => (
				<MultiProgress key={item.label} items={item.items} label={item.label} />
			))}
		</Flex>
	);
};

export default StatsSection;
